import type {Step} from "../../components/stepper/Step.ts";
import {CustomerAnalysisOptionsWidget} from "./CustomerAnalysisOptionsWidget.tsx";
import {useAtomValue} from "jotai";
import {ApiAtom} from "../../common-process/1-metl-connection/MetlConnectionProperties.ts";
import {areCustomerOptionsSet, CustomerAnalysisOptionsAtom} from "./CustomerAnalysisOptions.ts";

export function useCustomerAnalysisOptionsStep(): Step {
    const api = useAtomValue(ApiAtom)
    const options = useAtomValue(CustomerAnalysisOptionsAtom)
    return {
        name: "Analysis Options",
        isAvailable: api !== undefined,
        isCompleted: areCustomerOptionsSet(options),
        Widget: CustomerAnalysisOptionsWidget
    }
}